export const faq = {
  badge: "FAQ",
  title: "Perguntas frequentes",
  subtitle: "Tudo o que você precisa saber sobre a DONKEY TRAVEL",
  items: {
    q1: {
      question: "Como funciona o sistema de Noites?",
      answer:
        "É uma troca direta entre dois proprietários. Vocês concordam com as datas (simultâneas ou diferidas) e as modalidades. Sem pontos, sem cálculos complicados, apenas humano.",
    },
    q2: {
      question: "Devo trocar ao mesmo tempo?",
      answer:
        "Não! É todo o interesse do nosso sistema flexível. Você pode acolher João em abril e ir para a casa dele em outubro. Isso também permite se conhecer na entrega das chaves!",
    },
    q3: {
      question: "Como os membros são verificados?",
      answer:
        "Todos os membros devem ser proprietários Airbnb verificados. Também verificamos a identidade, a casa e as avaliações Airbnb de cada membro para garantir a segurança da comunidade.",
    },
    q4: {
      question: "O que acontece em caso de problema?",
      answer:
        "Nossa equipe de suporte está disponível 7 dias por semana para acompanhá-lo. Além disso, nosso sistema de avaliações e notas permite manter uma comunidade de confiança e resolver rapidamente qualquer problema.",
    },
    q5: {
      question: "Existem taxas ocultas?",
      answer:
        "Não, nenhuma taxa oculta. Você paga apenas sua assinatura anual de acordo com a área geográfica escolhida. As trocas são então totalmente gratuitas, sem comissão nem taxas adicionais.",
    },
    q6: {
      question: "Posso escolher quem fica na minha casa?",
      answer:
        "Absolutamente! Você tem controle total. Você pode consultar os perfis, ler as avaliações e aceitar ou recusar cada pedido de troca de acordo com suas preferências.",
    },
    q7: {
      question: "Minha casa está segurada durante as trocas?",
      answer:
        "Sim, todas as trocas estão cobertas pelo nosso seguro parceiro. Além disso, recomendamos verificar seu seguro residencial para uma proteção ideal.",
    },
    q8: {
      question: "Com quanto tempo de antecedência devo reservar?",
      answer:
        "Isso depende de cada proprietário. Alguns aceitam reservas de última hora, outros preferem planejar com vários meses de antecedência. Recomendamos reservar pelo menos 2-3 semanas antes.",
    },
  },
  cta: {
    title: "Você tem outras perguntas?",
    subtitle:
      "Nossa equipe está aqui para ajudá-lo a iniciar sua aventura DONKEY TRAVEL",
    button: "Contacte-nos",
  },
};
